export default __webpack_public_path__ + "alberta-match.92d6438eb3190a1d3bf7.svg";